const ApartmentsLayerIcon = () => {

  const iconStyles = `
    .icon_ct {
      fill: none;
      stroke: currentColor;
      stroke-width: 2;
      pointer-events: none;
    }
    .icon_icon_bg {
      fill:rgba(0, 0, 0, 0);
      stroke: currentColor;
      stroke-width: 2;
    }
    .icon_icon_bg:hover {
      fill: currentColor;
      fill-opacity: 0.3;
      stroke: currentColor;
      stroke-width: 2;
    }
    `;

	return (
		<svg
			viewBox={`0 0 100 100`}
			width={"100%"}
			height={"100%"}
    >
      <style>{iconStyles}</style>
        <path className="icon_bg" d="M68 40l-18 -11 -18 11v20l18 11 18 -11z" />
        <path className="icon_bg" d="M32 60l-18 -10v21l18 10z" />
        <path className="icon_bg" d="M68 60l-18 11 -18 -11v21l18 11 18 -11z" />
        <path className="icon_bg" d="M86 50l-18 10v21l18 -10z" />
        <path className="icon_bg" d="M68 19l-18 10 18 11v20l18 -10v-21z" />
        <path className="icon_bg" d="M68 19l-18 -11 -18 11 18 10z" />
        <path className="icon_bg" d="M50 29l-18 -10 -18 10v21l18 10v-20z" />
        <path className="icon_ct" d="M50 50l36 -21 M14 29l36 21 M50 92v-42 " />
    </svg>
  );
};

export default ApartmentsLayerIcon;